import { formatCurrencyInt } from '@edge/spark/utils'
import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const sumSaleAmount = ({ sumSaleAmount: _sumSaleAmount }: VehicleStatsByCompany): string =>
    _sumSaleAmount ? formatCurrencyInt(_sumSaleAmount) || '--' : '--'
